import React from 'react';
import { Star, StarHalf } from 'lucide-react';

export default function StarRating({ value, size = 18 }) {
  const v = value || 0;
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (v >= i) stars.push(<Star key={i} size={size} className="star-filled" fill="currentColor" />);
    else if (v >= i - 0.5) stars.push(<StarHalf key={i} size={size} className="star-filled" fill="currentColor" />);
    else stars.push(<Star key={i} size={size} className="star-empty" />);
  }
  return <div className="star-rating">{stars}</div>;
}
